import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DataCopyWrapperDirective } from '../directives/formElements/dashboardTemplates/data-copy.wrapper.directive';
import { PageProgressIndicatorComponent } from './page-progress-indicator.component';
import { ProgressIndicatorComponent } from './progress-indicator.component';
import { SvgIconComponent } from './svg-icon.component';


@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        SvgIconComponent,
        DataCopyWrapperDirective,
        ProgressIndicatorComponent,
        PageProgressIndicatorComponent,
    ],
    exports: [
        SvgIconComponent,
        DataCopyWrapperDirective,
        ProgressIndicatorComponent,
        PageProgressIndicatorComponent,
    ],
})
export class SharedComponentsModule { }